<template><div><h1 id="abgleichsresultat-importieren" tabindex="-1"><a class="header-anchor" href="#abgleichsresultat-importieren"><span>Abgleichsresultat importieren...</span></a></h1>
<p>Abgleichsresultat importieren... — Import von Personen- und Adressdaten von der Aktualisierung mit einem Aktualisierungsdienst</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Mit Adressaktualisierung können Personendaten mit einem vordefinierten Aktualisierungsdienst aktualisiert werden. Für die Aktualisierung ist unter Umständen ein Abonnement/Account beim jeweiligen Anbieter notwendig. Der Abgleich von Fremdadressen ist bei einigen Aktualisierungsdiensten nicht vorgesehen. Folgende Aktualisierungsdienste werden zurzeit unterstützt:</p>
<table>
<thead>
<tr>
<th>Aktualisierungsdienst</th>
<th>Abgleich von Fremdadressen</th>
</tr>
</thead>
<tbody>
<tr>
<td>Adresspflege Online</td>
<td>ja</td>
</tr>
<tr>
<td>Adresspflege über Webservice</td>
<td>nein</td>
</tr>
<tr>
<td>CRIF</td>
<td>nein</td>
</tr>
<tr>
<td>Matchmove</td>
<td>ja</td>
</tr>
<tr>
<td>Multisource</td>
<td>nein</td>
</tr>
</tbody>
</table>
<p>Beim Import überprüft das Programm die gefundenen Mutationen, fügt die Adressänderungen in die Datenbank ein und erstellt ein Protokoll derjenigen Fälle, die nicht eindeutig zugewiesen werden konnten für die manuelle Nachbearbeitung. Bei Personen die als gestorben gemeldet wurden, werden zusätzlich alle allfälligen Zusagen per Tagesdatum terminiert.</p>
<h2 id="pfad" tabindex="-1"><a class="header-anchor" href="#pfad"><span>Pfad</span></a></h2>
<p>Personen → Datenpflege → Adressaktualisierung → Abgleichsresultat importieren...</p>
<h3 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h3>
<dl>
<dt>Job-ID</dt>
<dd>Eindeutige Nummer des Aktualisierungsjobs</dd>
<dt>Aktualisierungsdienst</dt>
<dd>Selektierter Aktualisierungsdienst</dd>
<dt>Adressstamm</dt>
<dd>Selektierter Adressstamm</dd>
<dt>Abgleichsresultat</dt>
<dd>Auswahl des Abgleichsresultats</dd>
<dt>Einlesen</dt>
<dd>Einlesen <span class="guimenuitem">definitiv</span> oder nur als <span class="guimenuitem">Test</span> (ohne Datenänderung).</dd>
</dl>
<h2 id="protokoll" tabindex="-1"><a class="header-anchor" href="#protokoll"><span>Protokoll</span></a></h2>
<p>Im folgenden Outputbeispiel sind die Elemente des Änderungsprotokolls exemplarisch aufgeführt. Dabei bedeuten:</p>
<dl>
<dt>Mutationsdaten</dt>
<dd>Mutationen werden von den Kunden nicht immer rechtzeitig gemeldet. Dies führt dazu, dass das &quot;Valutadatum&quot; der Mutation in der Vergangenheit, aber auch in der Zukunft liegen kann. Hier werden das älteste, das jüngste und das häufigste Mutationsdatum ausgewiesen. Der Median (das häufigste Datum) zeigt den Mutationsmonat an.</dd>
<dt>Mehrdeutige Fälle</dt>
<dd>Die aufgeführten Fälle sind manuell zu überprüfen und gegebenenfalls zu ändern.</dd>
</dl>
<p>Protokoll zeigt, welche Änderungen an den Daten vorgenommen wurden. Unter dem Titel &quot;Automatische Mutationen&quot; wird die Anzahl dieser Mutationen angezeigt. Unter dem Titel &quot;Mehrdeutige Fälle&quot; werden Adressen aufgelistet, welche zu überprüfen und zu bearbeiten sind.</p>
<p>Eine Adressmutation bei einer Adresse mit mehreren Vornamen wird nur dann automatisch durchgeführt, wenn die Adressmutation für alle Vornamen dieser Adresse zutrifft. Sonst wird die Adresse im Protokoll unter &quot;Mehrdeutige Fälle&quot; aufgelistet.</p>
<p>Jede Adressmutation erfolgt durch erfassen einer &quot;neuen Adresse&quot;, die mit einem regelmässigen Dienst in den Adressstamm überspielt wird.</p>
<h3 id="outputbeispiel" tabindex="-1"><a class="header-anchor" href="#outputbeispiel"><span>Outputbeispiel</span></a></h3>
<pre><code>    _Adressmutationen &lt;KUNDE&gt;, Oktober 2000_
    

    Dieses Protokoll zeigt, welche Änderungen an den Daten
    vorgenommen wurden. Unter dem Titel &quot;Mehrdeutige Fälle&quot; werden
    Adressen aufgelistet,
    welche zu überprüfen sind.

    Mutationsdaten:
    Minimum: 01.01.2000, Mitte(Median): 01.10.2000, Maximum: 11.01.2001


    _Automatische Mutationen_

    _insgesamt geändert: 3478_
</code></pre>
<table>
<thead>
<tr>
<th>davon</th>
<th>Umzugsadressen:</th>
<th>3154</th>
</tr>
</thead>
<tbody>
<tr>
<td></td>
<td>abgereist ohne neue Adresse:</td>
<td>49</td>
</tr>
<tr>
<td></td>
<td>verstorben:</td>
<td>285</td>
</tr>
<tr>
<td></td>
<td>amtliche Mutationen:</td>
<td>10</td>
</tr>
<tr>
<td>ausserdem</td>
<td>Haushaltverbindung gelöst:</td>
<td>24</td>
</tr>
</tbody>
</table>
<pre><code>    _Mehrdeutige Fälle: 103_
</code></pre>
<table>
<thead>
<tr>
<th>davon</th>
<th>abgereist, mehrere Vornamen:</th>
<th>0</th>
</tr>
</thead>
<tbody>
<tr>
<td></td>
<td>verstorben, mehrere Vornamen:</td>
<td>8</td>
</tr>
<tr>
<td></td>
<td>amtliche Mutationen, mehrere Vornamen:</td>
<td>2</td>
</tr>
<tr>
<td></td>
<td>umgezogen, mehrere Vornamen:</td>
<td>35</td>
</tr>
<tr>
<td></td>
<td>Anredecode verschieden:</td>
<td>58</td>
</tr>
</tbody>
</table>
<pre><code>    _Mehrdeutige Fälle_
    

    abgereist, mehrere Vornamen: 0
</code></pre>
<p>|  |
|  |
| Funtrade-Adresse | Mutationsadresse | abgereist |</p>
<p>verstorben, mehrere Vornamen: 8</p>
<p>|  |
|  |
| Funtrade-Adresse | verstorben | verstorben |
| 475397 (-S-)
Frau
Hildegard &amp; Werner Bellwald
Rathausstrasse 28
8570 Weinfelden | Frau
Hildegard Bellwald
Rathausstrasse 28
8570 Weinfelden | Frau
Hildegard Bellwald-Bornhauser |
| 1270553 (ZS-)
Familie
Ernst &amp; Ursina Bachmann
Hochgrütstrasse 41
8472 Seuzach | Frau
Ursina Bachmann
Hochgrütstrasse 41
8472 Seuzach | Frau
Ursina Bachmann-Martig |
| 1540316 (---)
Familie
Hansjörg &amp; Hilde Bendel
Weinmanngasse 110
8700 Küsnacht ZH | Frau
Hildegard Bendel
Weinmanngasse 110
8700 Küsnacht ZH | Frau
Hildegard Bendel-Ritter |
| 4452448 (---)
Rolf &amp; Rosemarie
Hauenstein-Burkhardt
Im Winkel 17
4107 Ettingen | Herr
Rolf Hauenstein
Im Winkel 17
4107 Ettingen | Herr
Rolf Hauenstein |</p>
<h2 id="welche-daten-werden-verwendet-input" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verwendet-input"><span>Welche Daten werden verwendet? (Input)</span></a></h2>
<p>Abgleichsdaten des Aktualisierungsdienstes (Personendaten).</p>
<h2 id="welche-daten-werden-verandert-oder-erzeugt" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verandert-oder-erzeugt"><span>Welche Daten werden verändert oder erzeugt?</span></a></h2>
<p>Personen- und Adressdaten inkl. Ereignisse für Mutationen.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refproc.adressaktualisierungstarten.html" title="Adressaktualisierung starten...">Adressabgleich starten...</RouteLink> , <RouteLink to="/referenz/refs/ft.refdata.adressaktualisierung.html" title="Adressaktualisierung">Adressaktualisierung</RouteLink></p>
</div></template>


